'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propsComparer = require('../../utils/propsComparer');

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _LACrownContainer = require('./LACrown/LACrownContainer');

var _LACrownContainer2 = _interopRequireDefault(_LACrownContainer);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _WhiteLabelCrownContainer = require('./WhiteLabelCrown/WhiteLabelCrownContainer');

var _WhiteLabelCrownContainer2 = _interopRequireDefault(_WhiteLabelCrownContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Crown = function (_Component) {
    (0, _inherits3.default)(Crown, _Component);

    function Crown() {
        (0, _classCallCheck3.default)(this, Crown);
        return (0, _possibleConstructorReturn3.default)(this, (Crown.__proto__ || (0, _getPrototypeOf2.default)(Crown)).apply(this, arguments));
    }

    (0, _createClass3.default)(Crown, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps, nextState) {
            return (0, _propsComparer2.default)(this.props, nextProps, ['location', 'whiteLabel']);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                location = _props.location,
                whiteLabel = _props.whiteLabel;


            return whiteLabel ? (0, _jsx3.default)(_WhiteLabelCrownContainer2.default, {}) : (0, _jsx3.default)(_LACrownContainer2.default, {
                location: location
            });
        }
    }]);
    return Crown;
}(_react.Component);

exports.default = Crown;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/Crown.js
// module id = 8tqB
// module chunks = 57